import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { DetailNavigasi } from '../../../models/master-user/detail-navigasi.model';
import { environment } from 'src/environments/environment';
import { DetailNavigasiAdapter } from '../../adapter/master-user/detail-navigasi.adapter.service';

@Injectable({
  providedIn: 'root',
})
export class DetailNavigasiApiService {
  private url = `${environment.urlV2}/detail-navigasi`;

  constructor(private http: HttpClient, private adapter: DetailNavigasiAdapter) {}

  public getByLogin(loginId: number, query?: string): Observable<DetailNavigasi[]> {
    return this.http.get(`${this.url}/login/${loginId}${query || ''}`).pipe(
      map((data: any) => {
        if (!data) return [];
        return data.responses.data.map((item: any) => this.adapter.adapt(item));
      }),
      catchError((err) => throwError(err))
    );
  }

  public createRecords(loginId: number, navItems: any[]): Observable<any> {
    return this.http
      .post(`${this.url}/login/${loginId}`, {
        navigationItems: navItems,
      })
      .pipe(catchError((err) => throwError(err)));
  }

  public updateRecords(loginId: number, navigationItems: any[]): Observable<any> {
    return this.http
      .post(`${this.url}/login/${loginId}/update-v2`, {
        navigationItems,
      })
      .pipe(catchError((err) => throwError(err)));
  }

  public createNavigasiRegistrasiKlinik(loginId: number, data: any): Observable<any> {
    return this.http
      .post(`${environment.urlV2}/detail-navigasi/login/${loginId}`, data)
      .pipe(catchError((err) => throwError(err)));
  }

  public getNavRestriction(loginId?: any, refId?: any): Observable<DetailNavigasi[]> {
    const getIdRef = refId ? `?idReferenceNavigasi=${refId}` : '';
    return this.http.get(`${this.url}/login/${loginId}${getIdRef}`).pipe(
      map((data: any) => {
        if (!data) return [];
        return data.responses.data.map((item: any) => this.adapter.adapt(item));
      }),
      catchError((err) => throwError(err))
    );
  }
}
